<template>
  <teleport to="body">
    <div class="processingBox">
      <div class="inner">
        <img class="logo" src="@/assets/images/logo_straight.svg" />
        <div class="loading">
          <div class="dots clearfix">
            <div></div>
            <div></div>
            <div></div>
          </div>
          <p class="text"><slot name="message">資料處理中</slot></p>
        </div>
      </div>
    </div>
  </teleport>
</template>

<script>
export default {
  name: "Loading"
};
</script>
